import axios from 'axios';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { MdTableBar, MdVisibility } from "react-icons/md";
import { MdVisibilityOff } from "react-icons/md";
import { startTransition } from 'react';
import { FaUtensils } from "react-icons/fa";
import placeholder from '../assets/images/1080.png'
import JoditEditor from 'jodit-react';
import Select from 'react-select'

import _constantUtil from '../utils/Constant';
import Loader from '../components/partials/Loader';
import config from '../config/config';
import mobileBar from '../assets/images/232213.jpg'

const {
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    EMPTY_STRING: emptyString,
    SEND_OTP_END_POINT,
} = _constantUtil;

function SignUp() {

    const [images, setImages] = useState([]);
    const [email, setEmail] = useState(emptyString);
    const [password, setPassword] = useState(emptyString);
    const [loading, setLoading] = useState(falseValue);
    const [otpSent, setOtpSent] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);
    const [profileImage, setProfileImage] = useState(placeholder);

    const [selectedServices, setSelectedServices] = useState([]);
    const [serviceOptions, setServiceOptions] = useState([
        { value: 'Full Bar Setup', label: 'Full Bar Setup' },
        { value: 'Custom Cocktail Menus', label: 'Custom Cocktail Menus' },
        { value: 'Bartender Hire', label: 'Bartender Hire' },
        { value: 'Branded Bars & Activations', label: 'Branded Bars & Activations' },
        { value: 'Glassware & Barware Rental', label: 'Glassware & Barware Rental' },
        { value: 'Dry Hire (Staff Only)', label: 'Dry Hire (Staff Only)' },
        { value: 'Alcohol & Non-Alcoholic Packages', label: 'Alcohol & Non-Alcoholic Packages' },
    ]);

    const [selectedTags, setSelectedTags] = useState([]);
    const [tagOptions, setTagOptions] = useState([
        { value: 'Premium', label: 'Premium' },
        { value: 'Cocktails', label: 'Cocktails' },
        { value: 'Corporate', label: 'Corporate' },
        { value: 'Weddings', label: 'Weddings' },
        { value: 'Branded Events', label: 'Branded Events' },
        { value: 'Dry Hire', label: 'Dry Hire' },
        { value: 'Custom Bars', label: 'Custom Bars' },
    ]);

    const [content, setContent] = useState('');
    const fileInputRef = useRef(null);

    const navigate = useNavigate();
    const [selected, setSelected] = useState({
        mobileBar: false,
        caterer: false,
    });

    // * handle category checkbox 
    const handleCheckboxChange = (name) => {
        setSelected((prev) => {
            const newSelected = {};

            // Set all to false
            for (const key in prev) {
                newSelected[key] = false;
            }

            // Set the clicked one to true
            newSelected[name] = true;

            return newSelected;
        });
    };

    //* handle change for textarea
    const handleChange = (e) => {
        const text = e.target.value;
        const wordCount = text.trim().split(/\s+/).filter(Boolean).length;

        if (wordCount <= 300) {
            setContent(text);
        }
    };

    // * handle image change
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setImages((prevImages) => {
            const combinedImages = [...prevImages, ...newImages];
            if (combinedImages.length > 5) {
                toast.error('Maximum 5 images are allowed.');
                return combinedImages.slice(0, 5);
            }
            return combinedImages;
        });
    };

    // * handle remove image
    const handleRemoveImage = (index) => {
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    };

    // * handle upload click
    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    // * handle profile image 
    const handleProfileImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(URL.createObjectURL(file));
        }
    };

    //* navigate to email verification
    useEffect(() => {
        if (otpSent) {
            navigate('/verify-otp', { state: { email, password } });
        }
    }, [otpSent, navigate, email, password]);

    //* execute send otp api
    function executeSendOTPapi(event) {
        //* prevent default
        event.preventDefault();
        setLoading(trueValue);
        setDisableButton(trueValue)
        const data = { email, password };

        //* api url
        const apiUrl = config.appBaseUrl + SEND_OTP_END_POINT;

        //* send otp
        axios.post(apiUrl, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            const result = res.data;
            if (result.status) {
                toast.success(result.message);
                setTimeout(() => {
                    setOtpSent(trueValue);
                    setLoading(falseValue);
                    setDisableButton(falseValue);
                }, 1500);
            } else {
                toast.error(result.message);
                setLoading(falseValue);
                setDisableButton(falseValue);
            }
        }).catch(error => {
            toast.error(error.message);
            setLoading(falseValue);
            setDisableButton(falseValue);
        });
    }

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className="grid">
                {/* //* left side content */}
                <div className="order__left centered" >
                    <div className="form">
                        <div className="logo text-center">
                            <h3 >Hire a Vendor for professionals</h3>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text-center'>Create an account or log in to manage your business.</p>
                        </div>

                        <div className="row">

                            {/* //* mobile bar category */}
                            <div className="col-12 col-md-6 mb-3 mb-md-0">
                                <li className={`sign-up-card  mb-0 ${selected.mobileBar ? 'golder-border' : ''}`} onClick={() => handleCheckboxChange('mobileBar')} style={{ cursor: 'pointer' }}>
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <MdTableBar size={40} />

                                        <h2>Mobile Bar</h2>

                                        <label className="checkbox-control m-0">
                                            <input
                                                type="checkbox"
                                                className="checkbox"
                                                checked={selected.mobileBar}
                                                readOnly
                                            />
                                        </label>
                                    </div>
                                </li>
                            </div>

                            {/* //*  caterer category */}
                            <div className="col-12 col-md-6  mb-0">
                                <li className={`sign-up-card mb-0 ${selected.caterer ? 'golder-border' : ''}`} onClick={() => handleCheckboxChange('caterer')} style={{ cursor: 'pointer' }}>
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <FaUtensils size={40} />
                                        <h2>Caterer</h2>
                                        <label className="checkbox-control m-0">
                                            <input
                                                type="checkbox"
                                                className="checkbox"
                                                checked={selected.caterer}
                                                readOnly
                                            />
                                        </label>
                                    </div>
                                </li>
                            </div>

                            {/* //* business name */}
                            <div className="col-12 col-md-12 mb-0">
                                <input
                                    type="text"
                                    id="business_name"
                                    name="business_name"
                                    placeholder="Enter business name"
                                    className="form-control mb-0"
                                    autoComplete="off"
                                />
                            </div>

                            {/* //* location */}
                            <div className="col-12 col-md-12 mb-0">
                                <input
                                    type="text"
                                    id="location"
                                    name="location"
                                    placeholder="Enter location"
                                    className="form-control mb-0"
                                    style={{ width: "100%", }}
                                />
                            </div>

                            {/* //* website */}
                            <div className="col-12 col-md-12 mb-3">
                                <input
                                    type="text"
                                    id="website"
                                    name="website"
                                    placeholder="Enter website"
                                    className="form-control mb-0"
                                    style={{ width: "100%", }}
                                />
                            </div>

                            {/* //* upload maximum 5 images */}
                            <div className="col-12 col-md-12 mb-3">
                                <div>
                                    <div
                                        onClick={handleUploadClick}
                                        className='d-flex align-items-center justify-content-center'
                                        style={{
                                            border: '2px dashed #aaa',
                                            borderRadius: '10px',
                                            padding: '10px',
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            backgroundColor: '#f9f9f9',
                                        }}
                                    >
                                        {images.length === 0 ? (
                                            <div>
                                                <strong>Click to upload images.</strong>
                                                <p className='mb-0'>Upload up to 5 files</p>
                                            </div>
                                        ) : (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                                                {images.map((img, index) => (
                                                    <div key={index} style={{ position: 'relative' }}>
                                                        <img
                                                            src={img.preview}
                                                            alt="preview"
                                                            width="100"
                                                            height="100"
                                                            style={{ objectFit: 'cover', borderRadius: '8px' }}
                                                        />
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation(); // Prevent triggering file input
                                                                handleRemoveImage(index);
                                                            }}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '-5px',
                                                                right: '-5px',
                                                                background: 'red',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '50%',
                                                                width: '20px',
                                                                height: '20px',
                                                                fontSize: '14px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <input
                                        type="file"
                                        multiple
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        ref={fileInputRef}
                                        onChange={handleImageChange}
                                    />
                                </div>
                            </div>

                            {/* //* services */}
                            <div className=' col-12 col-md-12 mb-3'>
                                <Select
                                    isMulti
                                    name="service"
                                    options={serviceOptions}
                                    value={selectedServices}
                                    className="basic-multi-select"
                                    classNamePrefix="selectd"
                                    placeholder="Select services..."
                                    onChange={(selectedOptions) => {
                                        setSelectedServices(selectedOptions);
                                    }}
                                />
                            </div>

                            {/* //* tags */}
                            <div className=' col-12 col-md-12 '>
                                <Select
                                    isMulti
                                    name="service"
                                    options={tagOptions}
                                    value={selectedTags}
                                    className="basic-multi-select"
                                    placeholder="Select tags..."
                                    classNamePrefix="select"
                                    onChange={(selectedOptions) => {
                                        setSelectedTags(selectedOptions);
                                    }}
                                />
                            </div>

                            {/* //* price */}
                            <div className="col-12 col-md-12 mb-3">
                                <input
                                    type="text"
                                    id="price_range"
                                    name="price_range"
                                    placeholder="Enter price "
                                    className="form-control mb-0"
                                    style={{ width: "100%", }}
                                />
                            </div>

                            {/* //* personal info */}
                            <div className="row align-items-center mb-3">
                                <div className="custom-card-signup w-100">
                                    {/* Title */}
                                    <div className="d-flex mb-2">
                                        <h5 className="mb-0">Personal Info</h5>
                                    </div>

                                    {/* //* Content - Image Left, Inputs Right */}
                                    <div className="row w-100 align-items-center">

                                        {/* //* Left side - Profile Image */}
                                        <div className="col-12 col-md-4 mb-3 mb-md-0 d-flex justify-content-center">
                                            <div style={{ position: 'relative', width: '150px', height: '150px', marginTop: '6px' }}>
                                                <img
                                                    src={profileImage} // Default image
                                                    alt="Profile"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        border: '2px solid #ccc',
                                                        borderRadius: '8px',
                                                    }}
                                                />
                                                <label
                                                    htmlFor="upload-photo"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-8px',
                                                        right: '-13px',
                                                        background: '#fff',
                                                        borderRadius: '50%',
                                                        padding: '3px 6px',
                                                        fontSize: '13px',
                                                        cursor: 'pointer',
                                                        boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                                                    }}
                                                >
                                                    🖉
                                                </label>
                                                <input
                                                    type="file"
                                                    id="upload-photo"
                                                    style={{ display: 'none' }}
                                                    accept="image/*"
                                                    onChange={handleProfileImage}
                                                />
                                            </div>
                                        </div>

                                        {/* //* Right side - Inputs */}
                                        <div className="col-12 col-md-8 pe-0">
                                            <div className="row">

                                                <div className="col-12 pe-0">
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        className="form-control mb-0"
                                                        style={{ padding: '5px 10px', }}
                                                        placeholder="Enter email"
                                                        autoComplete="off"
                                                    />
                                                </div>

                                                <div className="col-12 pe-0">
                                                    <input
                                                        type="number"
                                                        id="number_contact"
                                                        name="number_contact"
                                                        className="form-control mb-0"
                                                        style={{ padding: '5px 10px', }}
                                                        placeholder="Enter contact number"
                                                        autoComplete="off"
                                                    />
                                                </div>

                                                <div className="col-12 pe-0">
                                                    <input
                                                        type="text"
                                                        id="instagram"
                                                        name="instagram"
                                                        className="form-control mb-0"
                                                        style={{ padding: '5px 10px', }}
                                                        placeholder="Enter instagram id"
                                                        autoComplete="off"
                                                    />
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* //* text editor for description */}
                            <div className="col-12 mb-3">
                                <textarea
                                    value={content}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows={4}
                                    placeholder="Enter description (max 300 words)"
                                />
                                <div className="text-end text-sm text-gray-500 mt-1">
                                    {content.trim().split(/\s+/).filter(Boolean).length} / 300 words
                                </div>
                            </div>



                        </div>

                        <button
                            type="submit"
                            className="login__button"
                            // onClick={() => {
                            //     navigate('/dashboard');
                            // }}
                        >
                            Sign up
                        </button>

                        <div className="signup">
                            <label className="remember_me">Already have an account?</label>
                            <Link
                                to="/login"
                                className="forgot__password text-golden"
                                style={{ textDecoration: "none" }}
                            >
                                <strong>Login</strong>
                            </Link>
                        </div>

                    </div>
                </div>

                {/* //* right side image */}
                <div className="order__right centered no__overflow">
                    <img
                        className="img"
                        src={mobileBar}
                        alt="picture"
                    />
                </div>
            </div>
        </>
    );
}

export default SignUp;
